import { createSlice } from '@reduxjs/toolkit';
import { IUserState } from '../../../types/referrer/user';

const initialState: IUserState = {};

const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    setUserPhoneNumber(state, action) {
      state.phoneNumber = action.payload;
    },
    setUserId(state, action) {
      state.userId = action.payload;
    },
  },
});

export const {
  reducer: userReducer,
  actions: { setUserId, setUserPhoneNumber },
} = userSlice;
